import React, { useContext, useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { MyContext } from '../context/Context';
import { add_area_api, add_city_api, area_delete_api, area_details_api, city_delete_api, city_details_api, city_update_api, update_area_api } from '../api/api';
import { Link, useLocation } from 'react-router-dom';
import FormError from '../components/FormError';
import { toast } from 'react-toastify';

function Area() {

    const location = useLocation();
    const cityId = location.state?.cityId;
    const stateId = location.state?.stateId;

    const add_close_Ref = useRef(null);
    const update_close_Ref = useRef(null);
    // const { stateList, state_details_api_call } = useContext(MyContext);
    const [cityList, setCityList] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [inputArea, setInputArea] = useState({
        city_id: cityId ? cityId : "",
        area_name: "",
        pincode: "",
    });

    const [formError, setFormError] = useState({
        area_name: "",
        pincode: "",
    })


    // find state
    // const find_state = stateList && stateList.find((state) => state?.state_id === stateId)
    
    // find city
    // const find_city = cityList && cityList.find((city) => city?.city_id === cityId)


    useEffect(() => {
        fetch_city_details();
        // setTimeout(() => {
            fetch_area_details();
        // }, 10);
    }, []);


    const handle_change = (e) => {
        const { name, value } = e.target;

        if (name === 'pincode' && value.length > 6) {
            return;
        }

        setInputArea({
            ...inputArea,
            [name]: name === "pincode" ? value.replace(/[^0-9]/g, "").toString() : value
        });
    };


    //add area
    const add_area_api_call = async () => {
        const errors = {};
        if (!inputArea.area_name) {
            errors.area_name = 'Please enter area name!'
        }
        if (!inputArea.pincode) {
            errors.pincode = 'Please enter pincode!'
        }
        else if (!/^\d{6}$/.test(inputArea.pincode)) {
            errors.pincode = 'Pincode must be 6 digits!';
        }
        setFormError(errors);

        if (Object.keys(errors).length !== 0) {
            return;
        }
        try {
            const res = await add_area_api(inputArea);
            if (res.status === 200) {
                fetch_area_details();
                setInputArea(prevState => ({ ...prevState, area_name: "", pincode: "" }));
                toast.success("Area Added Successfully");
                add_close_Ref.current.click();
            }
        } catch (error) {
            console.error("Add area API error:", error);
            if (error.response && error.response.data && error.response.data.errors.length > 0) {
                const errors = {};
                // Map through the errors array and populate the errors object
                error.response.data.errors.forEach(err => {
                    errors[err.key] = err.message; // Assuming each error has 'name' and 'message'
                });
                setFormError(errors);
            }
        }
    };


    //fetch city details
    const fetch_city_details = async () => {
        try {
            const res = await city_details_api({city_id: cityId});
            if (res.status === 200) {
                setCityList(res.data.data[0]);
            }
        } catch (error) {
            console.error("City details API error:", error);
        }
    };


    //fetch area details
    const fetch_area_details = async () => {
        try {
            const res = await area_details_api({ state_id: stateId, city_id: cityId });
            if (res.status === 200) {
                setAreaList(res.data.data);
            }
        } catch (error) {
            console.error("Area details API error:", error);
        }
    };

    // console.log(stateId)
    // area delete
    const area_delete_api_call = async (id) => {
        try {
            const res = await area_delete_api(id);
            if (res.status === 200) {
                toast.success("Area Deleted Successfully");
                fetch_area_details();
            }
        } catch (error) {
            if(error.status === 400){
                toast.error(error.data.message);
            }
            console.error("Area delete api error", error);
        }
    };



    // selected city
    const selected_area = (id) => {
        const filter_area = areaList.filter((area) => area.area_id == id);
        setInputArea(filter_area[0]);
    };


    // area update
    const area_update_api_call = async () => {
        const errors = {};
        if (!inputArea.area_name) {
            errors.area_name = 'Please enter area name!'
        }
        if (!inputArea.pincode) {
            errors.pincode = 'Please enter pincode!'
        }
        else if (!/^\d{6}$/.test(inputArea.pincode)) {
            errors.pincode = 'Pincode must be 6 digits!';
        }
        setFormError(errors);

        if (Object.keys(errors).length !== 0) {
            return;
        }
        try {
            const res = await update_area_api(inputArea);
            if (res.status === 200) {
                fetch_area_details();
                toast.success("Area Updated Successfully");
                update_close_Ref.current.click();
            }
        } catch (error) {
            console.error("city update api error", error);
            if (error.response && error.response.data && error.response.data.errors.length > 0) {
                const errors = {};
                // Map through the errors array and populate the errors object
                error.response.data.errors.forEach(err => {
                    errors[err.key] = err.message; // Assuming each error has 'name' and 'message'
                });
                setFormError(errors);
            }
        }
    };


    const clearError = () => {
        const clearedErrors = {};

        Object.keys(formError).forEach(field => {
            clearedErrors[field] = "";
        });

        setFormError(clearedErrors);
    }



    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-12 col-xl-6 d-flex flex-column flex-sm-row">
                                <h1 className="m-0 mr-3">Area For</h1>
                                <select
                                    className="custom-select mb-3"
                                    style={{ width: "300px" }}
                                    name="state_id"
                                    value={cityId}
                                    onChange={handle_change}
                                    disabled
                                >
                                    <option value="">Select city...</option>
                                    <option value={cityList.city_id}>{cityList.city_name}</option>
                                </select>
                            </div>
                            <div className="col d-flex justify-content-end mb-3 mb-xl-0">
                                <span className='text-sm'>
                                    <Link to="/dashboard">Dashboard</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <Link to="/state">{cityList?.state_name}</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <Link to="/city" state={{ stateId: cityList.state_id }}>{cityList?.city_name}</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <span>Area</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex justify-content-end'>
                        <button
                            className='btn btn-naariyal-green'
                            data-toggle="modal"
                            data-backdrop="static"
                            data-target="#add-area"
                            onClick={() => {
                                setInputArea({
                                    ...inputArea,
                                    area_name: "",
                                    pincode: "",
                                })
                            }}
                        >
                            <i className="fas fa-plus mr-2"></i>
                            Add Area
                        </button>
                    </div>
                </div>



                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">

                                <div className="card">

                                    <div className="card-body">
                                        <div className='table-responsive'>
                                            <table id="example2" className="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Area</th>
                                                        <th>Pincode</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {areaList.length > 0 && areaList.map((area, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{area?.area_name}</td>
                                                            <td>{area?.pincode}</td>
                                                            <td >
                                                                <div className="btn-group">
                                                                    <button type="button" className="btn btn-naariyal-green dropdown-toggle" data-toggle="dropdown">Action</button>
                                                                    <div className="dropdown-menu" role="menu">
                                                                        <a
                                                                            className="dropdown-item text-info"
                                                                            data-toggle="modal"
                                                                            data-backdrop="static"
                                                                            data-target="#update_area"
                                                                            onClick={() => selected_area(area?.area_id)}
                                                                        >
                                                                            <i className="nav-icon fas fa-pencil mr-2"></i>
                                                                            Update
                                                                        </a>
                                                                        <div className="dropdown-divider"></div>
                                                                        <a
                                                                            className="dropdown-item text-danger"
                                                                            onClick={() => area_delete_api_call(area?.area_id)}
                                                                        >
                                                                            <i className="nav-icon fas fa-trash-alt mr-2"></i>
                                                                            Delete
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* add area modal */}
                    <div className="modal fade" id="add-area" tabIndex={-1} role="dialog" aria-labelledby="addCityModal" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header border-0">
                                    <h5>Add Area</h5>
                                    <button type="button" onClick={clearError} className="close" data-dismiss="modal" aria-label="Close" ref={add_close_Ref}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="input-group">
                                        <div className='w-100 mb-3'>
                                            <label htmlFor="city_id">City</label>
                                            <select
                                                className="custom-select"
                                                name="city_id"
                                                id='city_id'
                                                value={cityId}
                                                onChange={handle_change}
                                                disabled
                                            >
                                                <option value="">Select City...</option>
                                                <option value={cityList.city_id}>{cityList.city_name}</option>
                                            </select>
                                        </div>
                                        <div className='w-100 mb-3'>
                                            <label htmlFor="area_name">Area</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Area"
                                                id='area_name'
                                                name='area_name'
                                                value={inputArea.area_name}
                                                onChange={handle_change}
                                            />
                                            <FormError>
                                                {formError.area_name ? formError.area_name : ''}
                                            </FormError>
                                        </div>
                                        <div className='w-100'>
                                            <label htmlFor="pincode">Pincode</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Pincode"
                                                id='pincode'
                                                name='pincode'
                                                value={inputArea.pincode}
                                                onChange={handle_change}
                                            />
                                            <FormError>
                                                {formError.pincode ? formError.pincode : ''}
                                            </FormError>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer border-0">
                                    <button
                                        type="button"
                                        className="btn btn-naariyal-green w-25 m-auto"
                                        onClick={add_area_api_call}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* update area modal */}
                    <div className="modal fade" id="update_area" tabIndex={-1} role="dialog" aria-labelledby="addCityModal" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header border-0">
                                    <h5>
                                        Update Area
                                    </h5>
                                    <button type="button" onClick={clearError} className="close" data-dismiss="modal" aria-label="Close" ref={update_close_Ref}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="input-group">
                                        <div className='w-100 mb-3'>
                                            <label htmlFor="city_id">City</label>
                                            <select
                                                className="custom-select"
                                                name="city_id"
                                                value={cityId}
                                                onChange={handle_change}
                                                disabled
                                            >
                                                <option value="">Select City...</option>
                                                <option value={cityList.city_id}>{cityList.city_name}</option>
                                            </select>
                                        </div>
                                        <div className='w-100 mb-3'>
                                            <label htmlFor="area_name">Area</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Area"
                                                id='area_name'
                                                name='area_name'
                                                value={inputArea.area_name}
                                                onChange={handle_change}
                                            />
                                            <FormError>
                                                {formError.area_name ? formError.area_name : ''}
                                            </FormError>
                                        </div>
                                        <div className='w-100'>
                                            <label htmlFor="pincode">Pincode</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id='pincode'
                                                placeholder="Enter Pincode"
                                                name='pincode'
                                                value={inputArea.pincode}
                                                onChange={handle_change}
                                            />
                                            <FormError>
                                                {formError.pincode ? formError.pincode : ''}
                                            </FormError>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer border-0">
                                    <button
                                        type="button"
                                        className="btn btn-naariyal-green w-25 m-auto"
                                        onClick={() => area_update_api_call()}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
            <Footer />
        </div>
    );
}

export default Area;
